import { Link } from "react-router-dom";
import "./Sidebar.css";
import home from "../../../assets/home.svg";
import stock_reports from "../../../assets/stock_reports.svg";
import INVOICE from "../../../assets/InvoiceIcon.svg";

const Sidebar = () => {
  // const { setIsFormOpen } = useContext(FormProvider);

  // const closeRegisterFormHandler = (e) => {
  //   e.preventDefault();
  //   setIsFormOpen(false);
  // };

  return (
    <aside>
      <nav className="nav-container">
        <ul className="nav-list">
          <li className="list-item">
            <Link to="/supervisor" className="link ">
              <img src={home} className="img img-home" alt="" />
              <p className="desc ">Home</p>
            </Link>
          </li>

          <li className="list-item">
            <Link to="/stockist-report" className=" link link-reports">
              <img src={stock_reports} className="img img-reports" alt="" />
              <p className="desc desc-reports">
                Stockist
                <br /> Report
              </p>
            </Link>
          </li>
          <li className="list-item">
            <Link to="/invoice-page" className=" link link-reports">
              <img src={INVOICE} className="img img-reports" alt="" />
              <p className="desc desc-reports">
                Invoice <br />
              </p>
            </Link>
          </li>
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;
